var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModalCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.639 1.671a.75.75 0 10-1.06-1.06L.86 7.327a.75.75 0 101.06 1.06L8.64 1.672z",
    fill: "#CFCFE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.578 8.389a.75.75 0 001.061-1.06L1.922.61A.75.75 0 00.86 1.67L7.578 8.39z",
    fill: "#CFCFE6"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgOSA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNOC42Mzg5NyAxLjY3MTA3QzguOTMxODcgMS4zNzgxOCA4LjkzMTg3IDAuOTAzMzAxIDguNjM4OTcgMC42MTA0MDhDOC4zNDYwOCAwLjMxNzUxNSA3Ljg3MTIxIDAuMzE3NTE1IDcuNTc4MzEgMC42MTA0MDhMMC44NjA3OTggNy4zMjc5MkMwLjU2NzkwNSA3LjYyMDgyIDAuNTY3OTA1IDguMDk1NjkgMC44NjA3OTggOC4zODg1OEMxLjE1MzY5IDguNjgxNDggMS42Mjg1NyA4LjY4MTQ4IDEuOTIxNDYgOC4zODg1OEw4LjYzODk3IDEuNjcxMDdaIiBmaWxsPSIjQ0ZDRkU2Ii8+CjxwYXRoIGQ9Ik03LjU3ODQ0IDguMzg4NzNDNy44NzEzNCA4LjY4MTYyIDguMzQ2MjEgOC42ODE2MiA4LjYzOTEgOC4zODg3M0M4LjkzMiA4LjA5NTg0IDguOTMyIDcuNjIwOTYgOC42MzkxIDcuMzI4MDdMMS45MjE1OSAwLjYxMDU1NEMxLjYyODcgMC4zMTc2NjEgMS4xNTM4MiAwLjMxNzY2MSAwLjg2MDkyOSAwLjYxMDU1NEMwLjU2ODAzNiAwLjkwMzQ0NyAwLjU2ODAzNiAxLjM3ODMyIDAuODYwOTI5IDEuNjcxMjFMNy41Nzg0NCA4LjM4ODczWiIgZmlsbD0iI0NGQ0ZFNiIvPgo8L3N2Zz4K";
export { SvgModalCloseWhite as ReactComponent };